import React, { useMemo } from 'react';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import MetricsCard from '@/pages/dashboard/components/MetricsCard';
import { useIntl, useSelector } from 'umi';
import { getTips } from '@/pages/dashboard/utils/getExplainVal';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import classnames from 'classnames';

const SteamSalesCard = (props: any) => {
  const { config, dataKey, apiDataKey, className } = props;
  const { titleEn, titleCn, icon, titleIcon, dodData, formatRule, preUnit: unit, rainbowKey, explainEn, explainCn, valueCoefficient, subtitleEn, subtitleCn, dateFormat = "HH:mm" } = config || {};
  const { [apiDataKey]: apiData } = props?.data || {};
  const { locale } = useIntl(); // 中英切换方法
  const isEN = locale === LANGUAGE_EN;

  const explainInfo = useSelector((state: any) => state.dashboard?.explainInfo);
  const explain = getTips(explainInfo, rainbowKey, explainEn, explainCn);
  const { tipEn, tipCn } = explain;
  const data = {};
  dataKey?.forEach((key: string) => {
    data[key] = apiData?.data?.[key];
  });
  const subTitle = getLanguage(isEN, subtitleEn, subtitleCn);

  const metricsDataArray = useMemo(() => Object.keys(data).map(key => data[key]), [data]);
  const metricsInfo = metricsDataArray.map((item) => {
    // 判断是否存在 valueCoefficient，如果存在则除以 valueCoefficient，否则保持原值
    const currentCount = valueCoefficient
      ? item?.current_count / valueCoefficient
      : item?.current_count;

    return {
      current_time: item?.current_time,
      current_count: currentCount,
      dodData: [{
        ...dodData[0],
        thisTime: item?.current_time,
        lastTime: item?.dod_time,
        value: item?.dod,
        thisValue: currentCount,
        lastValue: item?.dod_count
      },
      {
        ...dodData[1],
        thisTime: item?.current_time,
        lastTime: item?.sdlw_time,
        value: item?.sdlw,
        thisValue: currentCount,
        lastValue: item?.sdlw_count
      }]
    };
  });

  const contentHeader = (
    <div className="cart-margin-text">
      <div>{dateTimeFormat(metricsInfo[0]?.current_time, dateFormat)}</div>
      {subTitle && <div>{subTitle}</div>}
    </div>
  );
  const preUnit = metricsInfo[0]?.current_count === '-' ? '' : unit;

  return (
    <MetricsCard
      titleEn={titleEn}
      titleCn={titleCn}
      className={classnames('dbd-realtime-sales-card', className)}
      value={metricsInfo[0]?.current_count}
      preUnit={preUnit}
      tipsEn={tipEn}
      tipsCn={tipCn}
      dodData={metricsInfo[0]?.dodData}
      icon={icon}
      titleIcon={titleIcon}
      contentHeader={contentHeader}
      formatRule={formatRule}
    >
    </MetricsCard>
  );
};

export default SteamSalesCard;